import React from "react";
import Button from "../../../components/ui/Button/Button";
import Modal from "../../../components/ui/Modal/Modal";

const ConfirmationModal = (props) => {
  const { image, steps, isDetail = false } = props;
  return (
    <div>
      <div className="mt-4 px-4 text-[12px]">
        <p className="font-bold text-[13px]">상세사유</p>
        <textarea
          type="text"
          value={`요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다. 요청 사유입니다`}
          rows={7}
          className="border outline-none border-border-grey resize-none p-1.5 rounded-[1px] w-full mt-2"
        />
      </div>
      <div className="my-4 text-[12px] px-4">
        <p className="font-bold mb-3 text-[13px]">첨부 파일 목록</p>
        <div className="h-[7rem] overflow-auto">
          {image.map((item, index) => (
            <p
              key={index}
              className="mt-2 text-[#0070ef] cursor-pointer underline"
            >
              {item}
            </p>
          ))}
        </div>
      </div>
      <div
        className={`border-t flex ${
          image.length === 0 && "justify-end"
        } px-4 pt-4  border-t-disable-grey`}
      >
        <div
          className={`${
            image.length === 0 || steps ? "hidden" : "w-full"
          } mr-2`}
        >
          <Modal
            hasCancel={false}
            description={<div className="px-2">다운로드 되었습니다.</div>}
          >
            <Button text={`전체 다운로드`} width={`${
            isDetail === true ? "w-[50%]" : "w-full"
          }`} />
          </Modal>
        </div>
        <div
          className={`${image.length === 0 ? "w-[50%]" : "w-full"} ${
            (steps || isDetail === true) && "hidden"
          }`}
        >
          <Modal
            submitText="취소승인"
            cancelText="취소거부"
            description={
              <div className="text-[11px] mb-1">
                <p className="mb-3">
                  해당 상품의 주문 취소요청이 접수되었습니다. 취소승인을 하시겠
                  습니까?
                </p>
                [유의사항 안내] ‘취소상세’ 먼저 확인 필요
                <br />
                1. 취소승인
                <br />
                (1) 신용카드 : 카드사 취소 승인은 영업일 기준에 따라 다름
                <br />
                (2) 무통장입금 : ‘취소승인’후, ‘환불 예정 금액’을 입금하신 후에
                최종 취소
                <br />
                승인 처리됨
                <br />
                2. 취소거부
                <br />
                주문취소가 거부되어 송장번호 입력이 가능
                <br />
              </div>
            }
          >
            <Button
              text={`불량접수 확인`}
              textColorDefault="text-white"
              bgColor="bg-primary-blue"
              borderColor="border border-primary-blue"
              width="w-full"
            />
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
